import React, { useState, useContext } from "react";
import MultiStepFormContext from "../MultiStepForm/MultiStepFormContext";
import { FaQuestionCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import OnboardingAccountSettingsInfoModal from "../modals/OnboardingAccountSettingsInfoModal";
import "./allaccountsteps.scss";
import {
  accSetting,
  accSoftwarePage,
  accSofywareName,
  fieldValidation,
  pagination,
  platformPartner,
  preQualification
} from "../../locales/en";
import {
  MYOB,
  QUICKBOOKS,
  RECKON,
  XERO,
  accountData
} from "../../utils/constants/appConstants";

const AccountSettings = () => {
  const {
    accountSettings,
    setAccountSettings,
    connectedSoftName,
    expenseAccount,
    liabilityAccount,
    expTaxGroup,
    libiTaxGroup,
    next,
    prev,
    handleUpdateOnboarding,
    refreshExpenseAccounts,
    refreshLiabilityAccounts
  } = useContext(MultiStepFormContext);
  const [infoModal, setInfoModal] = useState(false);

  const initialErrors = {
    feesCode: "",
    feesTaxCode: "",
    feesName: "",
    expanceSelect: "",
    advanceCode: "",
    advanceName: "",
    advanceTaxCode: "",
    liabilitySelect: ""
  };

  const [errors, setErrors] = useState(initialErrors);

  const handleInfoModal = () => {
    setInfoModal(!infoModal);
  };

  const handleSubmit = () => {
    let isValid = true;
    const newErrors = { ...errors };

    if (accountSettings?.activeFees === false) {
      if (!accountSettings.feesCode) {
        newErrors.feesCode = fieldValidation.required;
        isValid = false;
      } else {
        newErrors.feesCode = "";
      }
    }

    if (accountSettings?.activeFees === false) {
      if (!accountSettings.feesName) {
        newErrors.feesName = fieldValidation.required;
        isValid = false;
      } else {
        newErrors.feesName = "";
      }
    }

    if (accountSettings?.activeFees === true) {
      if (!accountSettings.expanceSelect) {
        newErrors.expanceSelect = fieldValidation.required;
        isValid = false;
      } else {
        newErrors.expanceSelect = "";
      }
    }

    if (accountSettings?.activeLiability === false) {
      if (!accountSettings.advanceCode) {
        newErrors.advanceCode = fieldValidation.required;
        isValid = false;
      } else {
        newErrors.advanceCode = "";
      }
    }

    if (accountSettings?.activeLiability === false) {
      if (!accountSettings.advanceName) {
        newErrors.advanceName = fieldValidation.required;
        isValid = false;
      } else {
        newErrors.advanceName = "";
      }
    }

    if (accountSettings?.activeLiability === true) {
      if (!accountSettings.liabilitySelect) {
        newErrors.liabilitySelect = fieldValidation.required;
        isValid = false;
      } else {
        newErrors.liabilitySelect = "";
      }
    }

    setErrors(newErrors);

    if (isValid) {
      next();
    }
  };

  const fieldMapping = {
    feesCode: "expenseAccountCode",
    feesName: "expenseAccountName",
    expanceSelect: "expenseAccountUuid",
    activeFees: "isUsedExisitingExpenseAccount",
    feesTaxCode: "expenseAccountTaxCode",
    liabilitySelect: "liabilityAccountUuid",
    advanceCode: "liabilityAccountCode",
    advanceName: "liabilityAccountName",
    advanceTaxCode: "liabilityAccountTaxCode",
    activeLiability: "isUsedExistingLiabilityAccount"
  };

  const blurOnlyFields = ["feesCode", "feesName", "advanceName", "advanceCode"];

  const getAccountId = (data) => {
    if (connectedSoftName === accSoftwarePage?.xero) return data.AccountID;
    if (connectedSoftName === accSofywareName?.quickBooks) return data.Id;
    return null;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));

    let stateUpdate = { [name]: newValue };
    let apiOverrides = {};

    if (name === accountData?.activeFees) {
      if (newValue === true) {
        stateUpdate = { ...stateUpdate, feesCode: "", feesName: "" };
        apiOverrides = { expenseAccountCode: null, expenseAccountName: null };
      } else {
        stateUpdate = {
          ...stateUpdate,
          feesCode: accountData.defaultFeesCode,
          feesName: accountData.defaultFeesName
        };
        apiOverrides = {
          expenseAccountCode: accountData.defaultFeesCode,
          expenseAccountName: accountData.defaultFeesName
        };
      }
    } else if (name === accountData?.activeLiability) {
      if (newValue === true) {
        stateUpdate = { ...stateUpdate, advanceCode: "", advanceName: "" };
        apiOverrides = {
          liabilityAccountCode: null,
          liabilityAccountName: null
        };
      } else {
        stateUpdate = {
          ...stateUpdate,
          advanceCode: accountData.defaultAdvanceCode,
          advanceName: accountData.defaultAdvanceName
        };
        apiOverrides = {
          liabilityAccountCode: accountData.defaultAdvanceCode,
          liabilityAccountName: accountData.defaultAdvanceName
        };
      }
    }

    setAccountSettings((prevDetails) => ({
      ...prevDetails,
      ...stateUpdate
    }));

    if (!blurOnlyFields.includes(name)) {
      const originalName = fieldMapping[name] || name;
      const finalValue = type === "number" ? Number(newValue) : newValue;
      handleUpdateOnboarding(originalName, finalValue, false, apiOverrides);
    }

    if (
      name === accountData?.activeFees &&
      newValue === true &&
      (connectedSoftName === accSoftwarePage?.xero ||
        connectedSoftName === accSofywareName?.quickBooks)
    ) {
      refreshExpenseAccounts();
    }

    if (
      name === accountData?.activeLiability &&
      newValue === true &&
      (connectedSoftName === accSoftwarePage?.xero ||
        connectedSoftName === accSofywareName?.quickBooks)
    ) {
      refreshLiabilityAccounts();
    }

    if (
      name === accountData?.expanceSelect &&
      value &&
      (connectedSoftName === accSoftwarePage?.xero ||
        connectedSoftName === accSofywareName?.quickBooks)
    ) {
      const selected = expenseAccount?.find(
        (a) => String(getAccountId(a)) === String(value)
      );
      if (selected?.Name) {
        handleUpdateOnboarding(accountData?.expenseAccountName, selected.Name);
      }
    }

    if (
      name === accountData?.liabilitySelect &&
      value &&
      (connectedSoftName === accSoftwarePage?.xero ||
        connectedSoftName === accSofywareName?.quickBooks)
    ) {
      const selected = liabilityAccount?.find(
        (a) => String(getAccountId(a)) === String(value)
      );
      if (selected?.Name) {
        handleUpdateOnboarding(
          accountData?.liabilityAccountName,
          selected.Name
        );
      }
    }
  };
  const handleInputBlur = (e) => {
    const { name, value } = e.target;

    if (blurOnlyFields.includes(name)) {
      const originalName = fieldMapping[name] || name;
      handleUpdateOnboarding(originalName, value);
    }
  };

  const getTooltipContent = (connectedSoftName) => {
    switch (connectedSoftName) {
      case RECKON:
        return accSetting?.reckonText;
      case MYOB:
        return accSetting?.myobText;
      case XERO:
        return accSetting?.xeroText;
      default:
        return accSetting?.taxCodeText;
    }
  };

  const SUPPORTED_SOFTWARES = [RECKON, MYOB];

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <div className="step-wrap">
              <div className="step-title">
                <h3>{accSetting?.step3Title}</h3>
              </div>
              <div className="step-content mt-3 mb-3">
                <div className="aplyid-section">
                  <p>
                    {accSetting?.applyIdp1} {`${connectedSoftName} `}
                    {accSetting?.applyIdp2}
                    {` ${connectedSoftName} `} {accSetting?.applyIdp3}
                    {` ${connectedSoftName} `} {accSetting?.applyIdp4}
                    <Link onClick={handleInfoModal}>
                      {accSetting?.moreDetails}
                    </Link>
                  </p>
                </div>
              </div>
              <div className="step-content bank-details-wrap">
                <div className="bank-details-form addowners-form">
                  <div className="row mb-3">
                    <div className="col-md-12 mb-2">
                      <div className="d-flex justify-content-between">
                        <div className="left">
                          {accountSettings?.activeFees === true ? (
                            <label htmlFor="selectExpense">
                              {accSetting?.selectExpense}
                            </label>
                          ) : (
                            <label htmlFor="createExpense">
                              {accSetting?.createExpense}
                            </label>
                          )}
                        </div>
                        <div className="right">
                          {SUPPORTED_SOFTWARES.includes(connectedSoftName) && (
                            <label htmlFor="">
                              {`${accSetting?.taxCode} `}
                              <Link
                                data-tooltip-id="fees-code"
                                data-tooltip-content={
                                  accSetting?.tooltipContent1
                                }
                              >
                                <FaQuestionCircle />
                              </Link>
                            </label>
                          )}
                        </div>
                      </div>
                    </div>
                    {accountSettings?.activeFees === true ? (
                      <div className="col-md-9">
                        <div className="input-wrap mb-1">
                          <select
                            id="expanceSelect"
                            name="expanceSelect"
                            value={accountSettings?.expanceSelect}
                            onChange={handleInputChange}
                          >
                            <option value="">
                              {accSetting?.selectExpense}...
                            </option>
                            {connectedSoftName === RECKON &&
                              expenseAccount &&
                              expenseAccount?.map((data) => (
                                <option key={data.Id} value={data.Id}>
                                  {data.Name}
                                </option>
                              ))}
                            {connectedSoftName === MYOB &&
                              expenseAccount &&
                              expenseAccount?.map((data) => (
                                <option key={data.UID} value={data.UID}>
                                  {data.Name}
                                </option>
                              ))}
                            {connectedSoftName === XERO &&
                              expenseAccount &&
                              expenseAccount?.map((data) => (
                                <option
                                  key={data.AccountID}
                                  value={data.AccountID}
                                >
                                  {data.Name}
                                </option>
                              ))}
                            {connectedSoftName === QUICKBOOKS &&
                              expenseAccount &&
                              expenseAccount?.map((data) => (
                                <option key={data.Id} value={data.Id}>
                                  {data.Name}
                                </option>
                              ))}
                          </select>
                          {errors.expanceSelect && (
                            <div className="error-text mt-2">
                              {errors.expanceSelect}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="col-md-4">
                          <div className="input-wrap mb-1">
                            <input
                              type="text"
                              placeholder={accSetting?.code}
                              name="feesCode"
                              value={accountSettings?.feesCode}
                              onChange={handleInputChange}
                              onBlur={handleInputBlur}
                            />
                            {errors.feesCode && (
                              <div className="error-text mt-2">
                                {errors.feesCode}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-5">
                          <div className="input-wrap mb-1">
                            <input
                              type="text"
                              placeholder={platformPartner?.name}
                              name="feesName"
                              value={accountSettings?.feesName}
                              onChange={handleInputChange}
                              onBlur={handleInputBlur}
                            />
                            {errors.feesName && (
                              <div className="error-text mt-2">
                                {errors.feesName}
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    )}

                    {SUPPORTED_SOFTWARES.includes(connectedSoftName) && (
                      <div className="col-md-3">
                        <div className="input-wrap mb-1">
                          <select
                            id="feesTaxCode"
                            name="feesTaxCode"
                            value={accountSettings?.feesTaxCode}
                            onChange={handleInputChange}
                          >
                            {connectedSoftName === RECKON &&
                              expTaxGroup &&
                              expTaxGroup?.map((data) => (
                                <option key={data.Id} value={data.Id}>
                                  {data.Name}
                                </option>
                              ))}
                            {connectedSoftName === MYOB &&
                              expTaxGroup &&
                              expTaxGroup?.map((data) => (
                                <option key={data.UID} value={data.UID}>
                                  {data.Code}
                                </option>
                              ))}
                          </select>
                          {errors.feesTaxCode && (
                            <div className="error-text mt-2">
                              {errors.feesTaxCode}
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    <div className="col-md-12 mt-2">
                      <div className="input-wrap label-input-radio">
                        <input
                          type="checkbox"
                          id="activeFeesCheckBox"
                          name="activeFees"
                          checked={accountSettings?.activeFees}
                          onChange={handleInputChange}
                          className="hidecheckbox"
                        />
                        {accountSettings?.activeFees === true ? (
                          <label
                            className="primary-color"
                            htmlFor="activeFeesCheckBox"
                          >
                            {preQualification?.back}
                          </label>
                        ) : (
                          <label htmlFor="activeFeesCheckBox">
                            {accSetting?.orSelect}
                          </label>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-12 mb-2">
                      <div className="d-flex justify-content-between">
                        <div className="left">
                          {accountSettings?.activeLiability === true ? (
                            <label htmlFor="">
                              {accSetting?.selectCurrent}
                            </label>
                          ) : (
                            <label htmlFor="">
                              {accSetting?.createCurrent}
                            </label>
                          )}
                        </div>
                        <div className="right">
                          {SUPPORTED_SOFTWARES.includes(connectedSoftName) && (
                            <label htmlFor="">
                              {`${accSetting?.taxCode} `}
                              <Link
                                data-tooltip-id="fees-code"
                                data-tooltip-content={getTooltipContent(
                                  connectedSoftName
                                )}
                              >
                                <FaQuestionCircle />
                              </Link>
                            </label>
                          )}
                        </div>
                      </div>
                    </div>
                    {accountSettings?.activeLiability === true ? (
                      <div className="col-md-9">
                        <div className="input-wrap mb-1">
                          <select
                            id="liabilitySelect"
                            name="liabilitySelect"
                            value={accountSettings?.liabilitySelect}
                            onChange={handleInputChange}
                          >
                            <option value="">
                              {accSetting.selectLiability}...
                            </option>
                            {connectedSoftName === RECKON &&
                              liabilityAccount &&
                              liabilityAccount?.map((data) => (
                                <option key={data.Id} value={data.Id}>
                                  {data.Name}
                                </option>
                              ))}
                            {connectedSoftName === MYOB &&
                              liabilityAccount &&
                              liabilityAccount?.map((data) => (
                                <option key={data.UID} value={data.UID}>
                                  {data.Name}
                                </option>
                              ))}
                            {connectedSoftName === XERO &&
                              liabilityAccount &&
                              liabilityAccount?.map((data) => (
                                <option
                                  key={data.AccountID}
                                  value={data.AccountID}
                                >
                                  {data.Name}
                                </option>
                              ))}
                            {connectedSoftName === QUICKBOOKS &&
                              liabilityAccount &&
                              liabilityAccount?.map((data) => (
                                <option key={data.Id} value={data.Id}>
                                  {data.Name}
                                </option>
                              ))}
                          </select>
                          {errors.liabilitySelect && (
                            <div className="error-text mt-2">
                              {errors.liabilitySelect}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="col-md-4">
                          <div className="input-wrap mb-1">
                            <input
                              type="text"
                              placeholder="Code"
                              name="advanceCode"
                              value={accountSettings?.advanceCode}
                              onChange={handleInputChange}
                              onBlur={handleInputBlur}
                            />
                            {errors.advanceCode && (
                              <div className="error-text mt-2">
                                {errors.advanceCode}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-5">
                          <div className="input-wrap mb-1">
                            <input
                              type="text"
                              placeholder="Name"
                              name="advanceName"
                              value={accountSettings?.advanceName}
                              onChange={handleInputChange}
                              onBlur={handleInputBlur}
                            />
                            {errors.advanceName && (
                              <div className="error-text mt-2">
                                {errors.advanceName}
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    )}

                    {SUPPORTED_SOFTWARES.includes(connectedSoftName) && (
                      <div className="col-md-3">
                        <div className="input-wrap mb-1">
                          <select
                            id="advanceTaxCode"
                            name="advanceTaxCode"
                            value={accountSettings?.advanceTaxCode}
                            onChange={handleInputChange}
                          >
                            {connectedSoftName === RECKON &&
                              expTaxGroup &&
                              expTaxGroup?.map((data) => (
                                <option key={data.Id} value={data.Id}>
                                  {data.Name}
                                </option>
                              ))}
                            {connectedSoftName === MYOB &&
                              libiTaxGroup &&
                              libiTaxGroup?.map((data) => (
                                <option key={data.UID} value={data.UID}>
                                  {data.Code}
                                </option>
                              ))}
                          </select>
                          {errors.advanceTaxCode && (
                            <div className="error-text mt-2">
                              {errors.advanceTaxCode}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    <div className="col-md-12 mt-2">
                      <div className="input-wrap label-input-radio">
                        <input
                          type="checkbox"
                          id="activeLiabilityCheckBox"
                          name="activeLiability"
                          checked={accountSettings?.activeLiability}
                          onChange={handleInputChange}
                          className="hidecheckbox"
                        />
                        {accountSettings?.activeLiability === true ? (
                          <label
                            className="primary-color"
                            htmlFor="activeLiabilityCheckBox"
                          >
                            {preQualification?.back}
                          </label>
                        ) : (
                          <label htmlFor="activeLiabilityCheckBox">
                            {accSetting?.orSelect2}
                          </label>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="step-btn-group d-flex justify-content-center align-items-center mt-5 mb-5 flex-wrap">
        <div className="prev-btn p-1">
          <button type="button" className="btn btn-primary" onClick={prev}>
            {pagination.previous}
          </button>
        </div>
        <div className="next-btn p-1">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSubmit}
          >
            {pagination.next}
          </button>
        </div>
      </div>

      <Tooltip id="fees-code" className="small_tooltip_account" />
      <OnboardingAccountSettingsInfoModal
        isOpen={infoModal}
        toggle={handleInfoModal}
        connectedSoftName={connectedSoftName}
      />
    </>
  );
};

export default AccountSettings;
